<template>
<!-- v-if="pageId==='11'" -->
	<div   class="function_wrap"   data-type='1'  :style="!isPhone? 'width:1050px;':'widthL95%'  ">
         <consult v-if="!isPhone"></consult>
            <div :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' "   :style="'background-color: #fff; min-height:'+(screenHeight-80)+'px;'" >
                <h1 class="function_wrap_title">诉讼费计算器</h1>
                <div class="function_wrap_title_EN">LEGAL FEES CALCULATOR</div>
                
                <div class='optionitem' >   
                    <div class="optionitem item_name">受理类型：</div>
                  <div  class="optionitem item_detail" >
                        <el-select v-model="index" placeholder="请选择" style="width:100%;" >
                            <el-option
                                v-for="item in kind"
                                :key="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>    
                <div class='optionitem' >   
                    <div class="optionitem item_name" >输入金额：</div>
                    <div class="optionitem item_detail" > <el-input type='number' min=0 v-model="inputValue" placeholder="请输入金额"></el-input> </div>
                </div>  
                <div class='optionitem' >   
                    <div class="optionitem item_name">是否减半：</div>
                    <div class="optionitem item_detail"> 
                        <el-radio v-model="ishalf" label="1" border>否</el-radio>
                        <el-radio v-model="ishalf" label="2" border>是</el-radio>
                    </div>
                </div>  
                <div  style="margin-top:60px">
                    <!-- <button @click="alert('ok')" type="button">Click Me!</button>
                    <button type="button">Cancle!</button> -->
                    <el-row>
                        <el-button @click="bindcalculate" type="primary">确定</el-button>
                        <el-button @click="resetEvent" type="warning" style="margin-left: 50px;">清空</el-button>
                
                    </el-row>
                </div>


                <div class="result">
                    <h4>计算结果：</h4>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;案件受理费：{{result1}}元</p>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;财产保全费：{{result2}}元</p>
                    <p  style="font-weight:600;margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算结果仅供参考&nbsp;&nbsp; 数据来源《诉讼费用缴纳办法》</p>
                    <!-- <p>{{inputValue}}</p> -->
                </div>

               
            </div>   


    </div>
</template>

<script>

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

var filters = {
    toFix: function (value) {
        return value.toFixed(2)//此处2为保留两位小数
    }
}  


import { IncUseNumber } from '@/assets/js/cal/cal';  

import consult from '@/components/ads/consult.vue' 
	export default {
        metaInfo: {
            title: '诉讼费计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '诉讼费,诉讼费计算,律师工具,找律师,免费法律咨询'
            }],
      
        },
        name: 'legalfee',
          components: { 
                consult
            
            },
        // metaInfo () {
        //     return {
        //         title: '诉讼费计算器'
        //     }
        // },
        props: {
			// isPhone: Boolean
		},
		// placeholder:"hi",
        data() {
			return { 
                placeholder:"hi",
                kind: [ '一般财产案件' ,   '离婚无财产案件' ,  '侵害姓名、名称、肖像、名誉、荣誉以及其他人格权案件' , '商标、专利、海商行政案件' , '其他行政案件' ,  '知识产权案件' ,  '申请公示催告' ,  '申请撤销仲裁裁决或认定仲裁裁决效力' ,  '申请破产' ],
                index:'一般财产案件',
                inputValue:'',
                result1:0,
                result2:0,
                halfleft:"halfyes",    
                halfright: "halfno",
                half_bg1:'width:60px;height:30px;',
                half_bg2:"margin-left:120px;width:60px;height:30px; background-color: #dddddd;",
                ishalf:'1',
                // v_PhoneMode:isphone,
                isPhone:false,
                screenWidth:window.innerWidth,
			    screenHeight:window.innerHeight,
            }

        },
        created(){
            this.isPhone=isphone()
            window.console.log('this.isPhone:',this.isPhone)
        },

        mounted(){
            IncUseNumber('legalfee')

        },

        methods:{
            // TurnToFunction(e){
            //     window.console.log('TurnToFunction')
            //     window.console.log(e.srcElement.dataset.type)
            //     this.$emit('ChangeFunctionBox',e.srcElement.dataset.type); 

            // },

        bindhalf1:function(){
            this.halfleft='halfno';
            this.halfright='halfyes';
            this.half_bg1='width:60px;background-color: #dddddd;height:30px;';
            this.half_bg2='margin-left:120px;width:60px;height:30px; ';
  
        },

        bindhalf2: function () {
            this.halfleft='halfyes';
            this.halfright='halfno';
            this.half_bg1='width:60px;height:30px;';
            this.half_bg2='margin-left:120px;width:60px;height:30px; background-color: #dddddd;' ;

        },
   
        bindPickerChange(e){
            this.index=e.detail.value;
      
        },
        resetEvent(){
            this.inputValue='';
            this.result1=0;
            this.result2=0;

        },


        bindcalculate: function () {
            var t = this.inputValue;
            var x=0;
            var y=0;

            switch (this.index) {
                case '一般财产案件':
                    if (t <= 10000) {
                    x = 50;
                    }
                    else {
                    if (t <= 100000) {
                        x = t * 0.025 - 200;
                    }
                    else {
                        if (t <= 200000) {
                        x = t * 0.02 + 300;
                        }
                        else {
                        if (t <= 500000) {
                            x = t * 0.015 + 1300;
                        }
                        else {
                            if (t <= 1000000) {
                            x = t * 0.01 + 3800;
                            }
                            else {
                            if (t <= 2000000) {
                                x = t * 0.009 + 4800;
                            }
                            else {
                                if (t <= 5000000) {
                                x = t * 0.008 + 6800;
                                }
                                else {
                                if (t <= 10000000) {
                                    x = t * 0.007 + 11800;
                                }
                                else {
                                    if (t <= 20000000) {
                                    x = t * 0.006 + 21800;
                                    }
                                    else {
                                    if (t > 20000000) {
                                        x = t * 0.005 + 41800;
                                    }
                                    }
                                }
                                }
                            }
                            }
                        }
                        }
                    }
                    }
                break;

                case '离婚无财产案件':
                    if (t > 200000) {
                    x = (t - 200000) * 0.005;
                    }
                    else { x = 0;
                    x = x + 200;
                } 
                break;
                


                case '侵害姓名、名称、肖像、名誉、荣誉以及其他人格权案件':
                            
                    if (t == 0) {
                    x = 0;
                    }
                    else {
                    if ((t <= 50000) && (t > 0)) {
                        x = 0;
                    }
                    else {
                        if (t <= 100000) {
                        x = (t - 50000) * 0.01;
                        }
                        else {
                        x = (t - 100000) * 0.005 + 50000 * 0.01;
                        }
                    }
                    }
                    x = x + 300;
                break;


                case '商标、专利、海商行政案件':
                    x = 100;
                break;

                case "其他行政案件":
                    x = 50;
                break;

                case "知识产权案件":
                    if (t <= 10000) {
                    x = 50;
                    }
                    else {
                    if (t <= 100000) {
                        x = t * 0.025 - 200;
                    }
                    else {
                        if (t <= 200000) {
                        x = t * 0.02 + 300;
                        }
                        else {
                        if (t <= 500000) {
                            x = t * 0.015 + 1300;
                        }
                        else {
                            if (t <= 1000000) {
                            x = t * 0.01 + 3800;
                            }
                            else {
                            if (t <= 2000000) {
                                x = t * 0.009 + 4800;
                            }
                            else {
                                if (t <= 5000000) {
                                x = t * 0.008 + 6800;
                                }
                                else {
                                if (t <= 10000000) {
                                    x = t * 0.007 + 11800;
                                }
                                else {
                                    if (t <= 20000000) {
                                    x = t * 0.006 + 21800;
                                    }
                                    else {
                                    if (t > 20000000) {
                                        x = t * 0.005 + 41800;
                                    }
                                    }
                                }
                                }
                            }
                            }
                        }
                        }
                    }
                    }
                break;


                case "申请公示催告":
                    x = 100;
                break;
            

                case '申请撤销仲裁裁决或认定仲裁裁决效力':
                    x = 400;
                break;
                
                case "申请破产":
                    if (t <= 10000) {
                    x = 50;
                    }
                    else {
                    if (t <= 100000) {
                        x = t * 0.025 - 200;
                    }
                    else {
                        if (t <= 200000) {
                        x = t * 0.02 + 300;
                        }
                        else {
                        if (t <= 500000) {
                            x = t * 0.015 + 1300;
                        }
                        else {
                            if (t <= 1000000) {
                            x = t * 0.01 + 3800;
                            }
                            else {
                            if (t <= 2000000) {
                                x = t * 0.009 + 4800;
                            }
                            else {
                                if (t <= 5000000) {
                                x = t * 0.008 + 6800;
                                }
                                else {
                                if (t <= 10000000) {
                                    x = t * 0.007 + 11800;
                                }
                                else {
                                    if (t <= 20000000) {
                                    x = t * 0.006 + 21800;
                                    }
                                    else {
                                    if (t > 20000000) {
                                        x = t * 0.005 + 41800;
                                    }
                                    }
                                }
                                }
                            }
                            }
                        }
                        }
                    }
                }
                    x = x / 2;
                    if (x > 300000) { x = 300000; }
                break;
           
           
            default:
 
                if (t <= 10000) {
                x = 50;
                }
                else {
                if (t <= 100000) {
                    x = t * 0.025 - 200;
                }
                else {
                    if (t <= 200000) {
                    x = t * 0.02 + 300;
                    }
                    else {
                    if (t <= 500000) {
                        x = t * 0.015 + 1300;
                    }
                    else {
                        if (t <= 1000000) {
                        x = t * 0.01 + 3800;
                        }
                        else {
                        if (t <= 2000000) {
                            x = t * 0.009 + 4800;
                        }
                        else {
                            if (t <= 5000000) {
                            x = t * 0.008 + 6800;
                            }
                            else {
                            if (t <= 10000000) {
                                x = t * 0.007 + 11800;
                            }
                            else {
                                if (t <= 20000000) {
                                x = t * 0.006 + 21800;
                                }
                                else {
                                if (t > 20000000) {
                                    x = t * 0.005 + 41800;
                                }
                                }
                            }
                            }
                        }
                        }
                    }
                    }
                }
                }
            
            }
     

            if (this.ishalf=='2'){
                x=x/2;

            }


            if (t <= 1000) {
            y = 30;
            }
            else {
            if (t <= 100000) {
                y = t * 0.01 + 20;
            }
            else {
                if (t <= 896000) {
                y = t * 0.005 + 520;
                }
                else {
                if (t > 896000) {
                    y = 5000;
                }
                }
            }  

        }

        this.result1= filters.toFix(x);
        this.result2= filters.toFix(y);


    





},


    }
    
	}
</script>

<style >
	body
{

    background-color: #f0f0f0;
  
} 
</style>
